module.exports = __webpack_public_path__ + "static/media/check-circle.3c1b7ec7.svg";